// import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock';

let bodyIsLocked = false;

//const options = {reserveScrollBarGap: true};
//const lockBody = (element) => disableBodyScroll(element, options);
//const unlockBody = (element) => enableBodyScroll(element, options);

const toggleBodyLock = (elementId) => {
    bodyIsLocked = !bodyIsLocked;

    setBodyLock(elementId, bodyIsLocked);
};

const setBodyLock = (elementId, value) => {
    bodyIsLocked = value;
    //const element = window.document.getElementById(elementId);

    if (bodyIsLocked) {
        //lockBody(element);
    } else {
        //unlockBody(element);
    }
};

export default {
    toggleBodyLock,
    setBodyLock,
};